import {ChangeDetectorRef, Component, forwardRef, Input, SimpleChanges} from "@angular/core";
import {BarcodeService} from "../services/barcode.service";
import {Barcode} from "../model/barcode.interface";
import {AbstractVisbosControl} from "../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormControl} from "@angular/forms";
import {AsynchronousBarcodeValidator} from "../../core/visbos-core/ui/forms/validators/barcode.async.validator";
import {
  ValidatorErrorCodes,
  ValidatorErrorHelpTexts
} from "../../core/visbos-core/ui/forms/validators/validator-error-codes";
import {appInjector} from "../../index";
import {Observable} from "rxjs/Observable";


@Component({
  selector: 'vb-new-barcode-form',
  templateUrl: './new-barcode-form.component.html',
  styleUrls: ['./new-barcode-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => NewBarcodeFormComponent)}]
})
export class NewBarcodeFormComponent extends AbstractVisbosControl<Barcode, FormControl> {

  @Input()
  showGenerateButton: boolean = true;

  @Input()
  stockItemCuid: Observable<string>;

  public GENERATE_BARCODE_HELP_TEXT = "Generiert automatisch den nächsten im System verfügbaren Barcode";

  ERRCODE_BARCODE_IN_USE;
  HELPTEXT_BARCODE_IN_USE;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, private bcService?: BarcodeService) {
    super(fb, cd, null);
    this.ERRCODE_BARCODE_IN_USE = ValidatorErrorCodes.ERRCODE_BARCODE_IN_USE;
    this.HELPTEXT_BARCODE_IN_USE = ValidatorErrorHelpTexts.HELPTEXT_BARCODE_IN_USE;
  }

  public setDefaultValues(item?: Barcode): { [controlKey: string]: any } | any {
    return this.setValue(item, 'ean');
  }


  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if ((changes.control || changes.stockItemCuid) && this.control) {
      this.control.setAsyncValidators(AsynchronousBarcodeValidator.checkBarcode(this.stockItemCuid));
    }

  }

  ngOnInit() {

    super.ngOnInit();

    this.control.setAsyncValidators(AsynchronousBarcodeValidator.checkBarcode(this.stockItemCuid));

    /*if (this.stockItemCuid instanceof Observable) {
     this.stockItemCuid.subscribe((cuid: any) => {
     console.info("StockItemCuid changed", [this.stockItemCuid]);
     if (cuid) {
     this.control.setAsyncValidators(AsynchronousBarcodeValidator.checkBarcode(cuid));
     }
     })
     } else {
     if (this.stockItemCuid) {
     this.control.setAsyncValidators(AsynchronousBarcodeValidator.checkBarcode(this.stockItemCuid));
     }
     }*/

  }

  buildControlContent(values?: Barcode, ...params): FormControl {
    return NewBarcodeFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);

    let ctrl = fb.control(null);

    return ctrl;
  }

  generateBarcode() {
    this.dataSubscriptions.push(this.bcService.getGeneratedBarcode().subscribe((bc: Barcode) => {
      this.control.setValue(bc.ean);
      this.control.markAsTouched();
    }));

  }

}



// WEBPACK FOOTER //
// ./src/app/identity/new-barcode-form/new-barcode-form.component.ts